import { isNil } from 'lodash';
import {
  isAddressComponent,
  isAuditCheckboxComponent,
  isAuditTagComponent,
  isAuditTextComponent,
  isCombinedTagsComponent,
  isDateComponent,
  isDateRangeComponent,
  isEmailComponent,
  isEntityBatchComponent,
  isFileComponent,
  isGeolocationComponent,
  isInputButtonComponent,
  isNumberComponent,
  isPersonComponent,
  isReferencedInComponent,
  isRelatedCardComponent,
  isRelatedCardLookupComponent,
  isScheduledAutomationComponent,
  isSignatureComponent,
  isStaticTextComponent,
  isSubformComponent,
  isTagComponent,
  isTextComponent,
  isTimeTrackerComponent,
  isTodoComponent,
  isUrlComponent,
} from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';

export function toComponentOneOf(
  item: API.AnyComponent | API.AnyComponentOverrides | null | undefined,
): API.ComponentOneOf | null {
  if (!isNil(item)) {
    if (isAddressComponent(item)) {
      return { addressComponent: item };
    }
    if (isAuditCheckboxComponent(item)) {
      return { auditCheckboxComponent: item };
    }
    if (isAuditTagComponent(item)) {
      return { auditTagComponent: item };
    }
    if (isAuditTextComponent(item)) {
      return { auditTextComponent: item };
    }
    if (isCombinedTagsComponent(item)) {
      return { combinedTagsComponent: item };
    }
    if (isDateComponent(item)) {
      return { dateComponent: item };
    }
    if (isDateRangeComponent(item)) {
      return { dateRangeComponent: item };
    }
    if (isEmailComponent(item)) {
      return { emailComponent: item };
    }
    if (isFileComponent(item)) {
      return { fileComponent: item };
    }
    if (isGeolocationComponent(item)) {
      return { geolocationComponent: item };
    }
    if (isNumberComponent(item)) {
      return { numberComponent: item };
    }
    if (isPersonComponent(item)) {
      return { personComponent: item };
    }
    if (isRelatedCardComponent(item)) {
      return { relatedCardComponent: item };
    }
    if (isRelatedCardLookupComponent(item)) {
      return { relatedCardLookupComponent: item };
    }
    if (isScheduledAutomationComponent(item)) {
      return { scheduledAutomationComponent: item };
    }
    if (isSignatureComponent(item)) {
      return { signatureComponent: item };
    }
    if (isSubformComponent(item)) {
      return { subformComponent: item };
    }
    if (isTextComponent(item)) {
      return { textComponent: item };
    }
    if (isTagComponent(item)) {
      return { tagComponent: item };
    }
    if (isTodoComponent(item)) {
      return { todoComponent: item };
    }
    if (isStaticTextComponent(item)) {
      return { staticTextComponent: item };
    }
    if (isInputButtonComponent(item)) {
      return { inputButtonComponent: item };
    }
    if (isTimeTrackerComponent(item)) {
      return { timeTrackerComponent: item };
    }
    if (isReferencedInComponent(item)) {
      return { referencedInComponent: item };
    }
    if (isEntityBatchComponent(item)) {
      return { entityBatchComponent: item };
    }
    if (isUrlComponent(item)) {
      return { urlComponent: item };
    }
  }
  return null;
}
